import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import {
  useFlags,
  useLocation,
  useModal,
  useQueryString,
  useSession
} from 'hooks'
import { Burger, Magnifier } from 'icons'
import {
  Button,
  Div,
  FlixxBalance,
  LangSelector,
  Logo,
  Menu,
  NavRoutes,
  SearchBar,
  Text
} from 'ui'
import useResponsive from 'utils/hooks/useResponsive'
import {
  BurgerBtn,
  Container,
  Nav
} from './styles'


const Header = () => {

  const { t } = useTranslation()

  const { isTab, isMobile } = useResponsive()
  const { isCommunitySectionEnabled } = useFlags()
  const { Modal: LoginModal } = useModal('welcome')
  const { isLoggedIn } = useSession();

  const { from } = useQueryString()
  const isFromWebview = from === 'webview'

  const [isDarken, setIsDarken] = useState(false)
  const [isOpenSideMenu, setIsOpenSideMenu] = useState(false)

  const openLogin = () => LoginModal.open()

  const { isCreators, isSearch } = useLocation()


  useEffect(() => {
    const scroll = () => {
      const seventyFivePercent = window.innerHeight * 0.75
      if (window.scrollY > seventyFivePercent) setIsDarken(true)
      else setIsDarken(false)
    }

    window.addEventListener('scroll', scroll)
    return () => window.removeEventListener('scroll', scroll)
  }, [])


  if (isFromWebview) return null


  return (
    <Container $isCreators={isCreators} isDarken={isDarken}>
      <Div
        display='flex'
        alignItems='center'
        gap={16}
        padding='10px 0'
      >
        <Nav>
          <Logo
            theme={isCreators ? 'light' : 'dark'}
            addCreators={isCreators}
            to={isCreators ? '/creators' : '/'}
          />

          {!isCreators && isCommunitySectionEnabled && (
            <NavRoutes />
          )}
        </Nav>

        {!isCreators && (
          isSearch
            ? !isTab && <SearchBar />
            : <Button size={isMobile ? 'small' : 'medium'} variant='icon' to='/search'><Magnifier /></Button>
        )}

        {isLoggedIn ? (
          <>
            <FlixxBalance />

            {!isCreators && (
              <BurgerBtn
                onClick={() => setIsOpenSideMenu(true)}
                variant='icon'
                size={isMobile ? 'small' : 'medium'}
              >
                <Burger />
                {/* <Avatar src={user.profile.avatar} /> */}
              </BurgerBtn>
            )}

            <Menu
              isOpen={isOpenSideMenu}
              onClose={() => setIsOpenSideMenu(false)}
            />
          </>
        ) : (
          <>
            {!isLoggedIn && <LangSelector />}

            <Div minWidth='max-content'>
              <Button onClick={openLogin}>
                <Text color='headline' >
                  {t("enter")}
                </Text>
              </Button>
            </Div>
          </>
        )}
      </Div>

      {isTab && isSearch && <SearchBar />}
    </Container>
  )
}

export default Header